import { Power0, TweenMax } from 'gsap';
import { Container, Sprite } from 'pixi.js';
import SoundManager from '../../../../Sound/SoundManager';
import { createOutlineText, createPixiText } from '../../../../Utils/Utils';
import { TileGoldMatch } from '../../../Animations/TileGoldMatch';
import Core from '../../../../Core/Core';

export class MissionsCoinsCollect extends Container {
    private rays: Sprite;
    private coins: Sprite;
    private rewardText: PIXI.Text;
    private tier: number;

    // private missionId: string;

    constructor(missionTier: number, missionId: string) {
        super();

        this.tier = missionTier;
        // this.missionId = missionId;

        this.rays = new PIXI.Sprite(PIXI.utils.TextureCache['commonui/opt-in_icon_rays']);
        this.rays.anchor.set(0.5);
        this.rays.scale.set(0.55);
        this.rays.x = 2;

        this.coins = new PIXI.Sprite(PIXI.utils.TextureCache['commonui/leaderboard-reward-coins']);
        this.coins.anchor.set(0.5);

        this.rewardText = createPixiText(
            Core.local.getText('reward'),
            new PIXI.Rectangle(
                this.coins.width * 0.5,
                -this.coins.height * 0.6,
                this.coins.width * 0.7,
                this.coins.height * 0.3
            ),
            'Baloo',
            20
        );
        this.rewardText.anchor.set(1, 0.5);

        this.enable();
        // this.on('pointerup', this.handlePointerDown.bind(this));

        this.addChild(this.rays, this.coins, this.rewardText);
    }

    /**
     * Stop the count down and kill any rays animation.
     */
    public destroy(options?: boolean | PIXI.DestroyOptions): void {
        TweenMax.killTweensOf(this.rays);
        super.destroy(options);
    }

    /**
     * Set as interactable, show coins, hide timer and start rays animation.
     */
    public enable(): void {
        this.interactive = true;
        this.buttonMode = true;

        this.coins.alpha = 1;

        this.rays.visible = true;
        this.rays.rotation = 0;
        TweenMax.to(this.rays, 5, {
            rotation: 2 * Math.PI, // 360
            repeat: -1,
            ease: Power0.easeNone,
        });
    }

    /**
     * Set as non-interactable, hide coins, show timer and kill rays animation.
     */
    public disable(): void {
        this.interactive = false;
        this.buttonMode = false;

        this.coins.alpha = 0.3;

        this.rays.visible = false;
        TweenMax.killTweensOf(this.rays);
    }

    public changeId(id: string) {
        // this.missionId = id;
    }

    public showClick() {
        this.disable();

        SoundManager.playSound('GameCoin');

        const coins = this.tier === 1 ? 30 : this.tier === 2 ? 60 : 100;
        this.playCoinAnimation(coins);
    }

    /* private async handlePointerDown(): Promise<void> {
        if (!this.dragging) {
            this.disable();

            const coins = this.tier === 1 ? 30 : this.tier === 2 ? 60 : 100;
            this.playCoinAnimation(coins);
            await waitForMs(500);
            this.emitter.emit(PopupActions.MISSION_COLLECT_COINS, [coins, this.missionId]);
        }
    } */

    private playCoinAnimation(coins: number): void {
        const anim = new TileGoldMatch();
        anim.position.set(6, 15);
        this.addChild(anim);

        const text = createOutlineText(
            `+${coins}\n${Core.local.getText('coins')}`,
            new PIXI.Rectangle(0, 15, 100, 50),
            'Baloo',
            24,
            24,
            0xffffff,
            0x006eba,
            4
        );
        this.addChild(text);

        TweenMax.to(text, 0.5, {
            y: 5,
            onComplete: () => {
                this.removeChild(text);
                text.destroy();
            },
        });
    }
}
